// DO NOT MODIFY - this file is auto-generated by build-icons.js
// @ts-nocheck
import React from 'react';
import Icon from '../shared/icon';

/* eslint-disable react/jsx-max-props-per-line,react/jsx-space-before-closing,react/jsx-tag-spacing */

const XIcon = (props) => (
  <Icon {...props}>
    {
      ({ color, width, height }) => (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 100 100">
          <path fill="inherit" d="M50 34.1L24.1 8.3c-4.3-4.5-11.5-4.5-15.8 0-4.5 4.4-4.5 11.5-.1 15.9L34 50.1 8.3 75.8c-4.4 4.4-4.4 11.6.1 15.9 4.3 4.4 11.5 4.4 15.9 0L50 65.9l25.9 25.8c4.4 4.4 11.5 4.4 15.9 0s4.4-11.6-.1-15.9L65.9 50.1l25.8-25.9c4.5-4.5 4.4-11.5.1-15.9-4.5-4.4-11.6-4.5-15.9 0L50 34.1z"/>
        </svg>
      )
    }
  </Icon>
);

export default XIcon;
